/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lofty_Patchy_Haddock_EnchantInputs */

const fr_lofty_patchy_haddock_enchant = /** @type {(inputs: Lofty_Patchy_Haddock_EnchantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissions`)
};

/**

* @param {Lofty_Patchy_Haddock_EnchantInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const lofty_patchy_haddock_enchant = /** @type {((inputs?: Lofty_Patchy_Haddock_EnchantInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lofty_Patchy_Haddock_EnchantInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_lofty_patchy_haddock_enchant(inputs)
});